// ----
// Close map modal
// ----

attachEvent('.map-modal__close, .map-modal__overlay', 'click', (ev) => {
  ev.target.closest('.map-modal').classList.remove('is-open-modal');
});
